import { defineStore } from 'pinia';

export const useDurationStore = defineStore('durationStore', {
  state: () => ({
    durationsMultiple: [],
    hotelDurationsMultiple: [],
    durationsMultipleOnlyHotel: [],
    hotelDurationsMultipleOnlyHotel: [],
    durationsMultipleOnlyAir: []
  }),
  getters: {
    selectDurationsMultiple: (state) => state.durationsMultiple,
    selectHotelDurationsMultiple: (state) => state.hotelDurationsMultiple,
    selectDurationsMultipleOnlyHotel: (state) => state.durationsMultipleOnlyHotel,
    selectHotelDurationsMultipleOnlyHotel: (state) => state.hotelDurationsMultipleOnlyHotel,
    selectDurationsMultipleOnlyAir: (state) => state.durationsMultipleOnlyAir
  },
  actions: {
    updateDurationsMultiple({ durations, index }) {
      this.durationsMultiple[index] = durations;
    },
    updateHotelDurationsMultiple({ hotelDurations, index }) {
      this.hotelDurationsMultiple[index] = hotelDurations;
    },
    updateDurationsMultipleOnlyHotel({ durations, index }) {
      this.durationsMultipleOnlyHotel[index] = durations;
    },
    updateHotelDurationsMultipleOnlyHotel({ hotelDurations, index }) {
      this.hotelDurationsMultipleOnlyHotel[index] = hotelDurations;
    },
    updateDurationsMultipleOnlyAir({ durations, index }) {
      this.durationsMultipleOnlyAir[index] = durations;
    }
  }
});
